import "@fortawesome/fontawesome-free/css/all.css";
import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";

import "ag-grid-enterprise";

// For copy to clipboard
import VueClipboard from "vue-clipboard2";
Vue.use(VueClipboard);

// import "vuetify/dist/vuetify.min.css";

// confirm dialog for Vuetify

import VuetifyConfirm from "vuetify-confirm";
Vue.use(VuetifyConfirm, {
  buttonTrueText: "OK",
  buttonFalseText: "Отмена",
  color: "error",
  icon: "warning",
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
